// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"113":"37dc82a7","132":"c009543e"}[chunkId] + ".chunk.css";
};